(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom_info_modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener("click", function (e) {
        if (e.target.closest(".info-modal-toggle")) {
            const wrapper = e.target.closest(".info-modal-wrapper");
            if (wrapper) {
            wrapper.classList.toggle("active");
            }
        }
    });
  } catch(e) { console.error(e); }
})();

})();
